import { FC, useState } from 'react';
import clsx from 'clsx';
import Menu from '../../molecules/Menu';
import type { IListElement } from '../../types/IListElement';
import { DTB_POPUP_Z } from '../popupZIndex';
import { DataTableWrapMode } from '../DataTable.types';
import { ROW_HEIGHT_HINT, ROW_HEIGHT_LABEL, ROW_HEIGHT_MODES, rowHeightTitle } from '../rowHeight';
import RowHeightIcon from './RowHeightIcon';

interface DataTableRowHeightButtonProps {
    wrapMode: DataTableWrapMode;
    onWrapModeChange: (mode: DataTableWrapMode) => void;
    /** Класс кнопки туллбара-владельца (у грида вложений свой). */
    className?: string;
}

/**
 * Высота строк кнопкой туллбара: иконка держит текущий режим на виду, клик
 * открывает меню из трёх режимов с описанием каждого. Ставится там, где эта
 * настройка единственная; если у владельца есть свои — меню «Настройки таблицы».
 */
const DataTableRowHeightButton: FC<DataTableRowHeightButtonProps> = ({
    wrapMode,
    onWrapModeChange,
    className = 'dtb__icon-btn',
}) => {
    const [opened, setOpened] = useState(false);
    const list: IListElement[] = [
        { label: 'Высота строк', isTitle: true },
        ...ROW_HEIGHT_MODES.map((mode): IListElement => ({
            label: ROW_HEIGHT_LABEL[mode],
            description: ROW_HEIGHT_HINT[mode],
            value: mode,
            radio: true,
            checked: mode === wrapMode,
            group: 'row-height',
            startAdornment: <RowHeightIcon mode={mode} size={20} />,
            handler: () => onWrapModeChange(mode),
        })),
    ];

    return (
        <Menu
            list={list}
            opened={opened}
            onOpenChange={setOpened}
            position="bottom-end"
            popoverProps={{ zIndex: DTB_POPUP_Z, listClassName: 'dtb-rh-menu' }}
            data-testid="dtb-row-height"
        >
            <button
                type="button"
                className={clsx(className, opened && 'is-active')}
                title={rowHeightTitle(wrapMode)}
                aria-label={rowHeightTitle(wrapMode)}
            >
                <RowHeightIcon mode={wrapMode} />
            </button>
        </Menu>
    );
};

export default DataTableRowHeightButton;
